export function parseJwt(token: string) {
  try {
    return JSON.parse(atob(decodeURIComponent(token).split(".")[1]))
  } catch (e) {
    return {}
  }
}
